export default "__VITE_ASSET__YQSi9rz0__"